import { Model } from "@shared/models/model";
import {Expose, Type} from "class-transformer";
import {Customer} from "@features/customers/models/customer.model";
import { User } from "../../users/models/user.model";
import {InvoiceStatus} from "@shared-features/enums/shipments.enum";

export class ShipmentInvoice extends Model {
  @Expose() id: number;

  // @Type(() => Shipment)
  // @Expose()
  // shipment: Shipment = new Shipment();

  @Expose()
  amount: number;

  @Expose()
  referenceNumber: string;

  @Expose()
  remarks: string;

  @Expose()
  rejectionReason: string;

  @Expose()
  status: InvoiceStatus;

  @Expose()
  paymentDate: number;

  @Expose()
  dueDate: number;

  @Expose()
  startDate: number;

  @Expose()
  invoiceDate: number;

  @Expose()
  endDate: number;

  @Expose()
  numberOfDays: number;

  @Expose()
  issuedTripsCount: number;

  @Expose()
  nonIssuedTripsCount: number;

  @Type(() => Customer)
  @Expose()
  customer: Customer = new Customer();

  @Expose()
  @Type(() => User)
  createdBy: User = new User();

  @Expose()
  @Type(() => User)
  updatedBy: User = new User();

  @Expose()
  @Type(() => User)
  rejectedBy: User = new User();

  @Expose()
  dueDays: number;

  @Expose()
  createdAt: number;

  @Expose()
  updatedAt: number;

  constructor() {
    super();
  }
}
